import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AppLayout from '@/layouts/AppLayout';
import DashboardView from '@/views/dashboard/DashboardView';
import CardWalletView from '@/views/card-wallet/CardWalletView';
import CardDetailView from '@/views/card-wallet/CardDetailView';
import BillingTemplatesView from '@/views/billing-templates/BillingTemplatesView';
import WalletLedgerView from '@/views/wallet-ledger/WalletLedgerView';
import ProfileSettingsView from '@/views/profile/ProfileSettingsView';
import TeamView from '@/views/team/TeamView';
import LoginView from '@/views/auth/LoginView';
import RegisterView from '@/views/auth/RegisterView';
import RequireAuth from '@/router/RequireAuth';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginView />} />
        <Route path="/register" element={<RegisterView />} />
        <Route
          element={
            <RequireAuth>
              <AppLayout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardView />} />
          <Route path="/cards" element={<CardWalletView />} />
          <Route path="/cards/:cardId" element={<CardDetailView />} />
          <Route path="/billing-templates" element={<BillingTemplatesView />} />
          <Route path="/wallet-ledger" element={<WalletLedgerView />} />
          <Route path="/team" element={<TeamView />} />
          <Route path="/profile" element={<ProfileSettingsView />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
